var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "site-columns",
      class: { "site-columns--full-width": _vm.isFullWidth },
    },
    [
      _c(
        "div",
        { staticClass: "site-columns__inner", style: _vm.gridStyle },
        _vm._l(_vm.columns, function (column) {
          return _c(
            "div",
            {
              key: column.id,
              staticClass: "site-columns__column",
              style: _vm.columnStyle(column),
            },
            _vm._l(column.blocks, function (childBlock) {
              return _c("site-block-renderer", {
                key: childBlock.id,
                attrs: { block: childBlock },
              })
            }),
            1
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }